<template>
  <v-container v-if="task"
               class="VV__ShowTask"
               fluid>

    <h1 class="text-h4 mb-4">
      Scheduled Task: {{ task.name }}
    </h1>
    <codemirror-json :code="JSON.stringify(task, null, 2)"
                     :options="{lineNumbers: true, lineWrapping: true, mode: 'javascript', theme: 'monokai'}">
    </codemirror-json>
  </v-container>
</template>
<style lang="scss">
.VV__ShowTask {
  height: 90%;

  .vue-codemirror {
    height: 100%;
    position: relative;
  }

  .CodeMirror {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: auto;
  }
}
</style>
<script>
import pepperFlowService from '../../../services/pepperFlowService';
import CodemirrorJson from '../components/CodeMirrorJson';

export default {
  components: {CodemirrorJson},
  data() {
    return {
      task: null,
    }
  },
  computed: {
    taskID() {
      return parseInt(this.$route.params.taskID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      pepperFlowService.getTask(this.taskID)
        .then(data => {
          this.task = data;
        })
    },
    deleteTask(task) {
      pepperFlowService.deleteTask(task.id)
        .then(() => {
          this.fetchData();
        })
    }
  }
}
</script>
